module.exports = __webpack_public_path__ + "img/samsung_galaxy_book_s.a87a0e5.png";